export const notificationsSlr = (state) => state.rightMenuState.notifications;
export const referralSlr = (state) => state.rightMenuState.referral;